(function () {
  let revealIncompatible = false;
  let scheduled = false;

  function applyFitment(root = document) {
    const api = window.RT70YMM;
    if (!api) return;
    const bike = api.YMM.get();
    const controls = document.querySelector('[data-rt70-fitment-controls]');
    if (controls) {
      controls.dataset.active = bike ? 'true' : 'false';
      const checkbox = controls.querySelector('[data-rt70-reveal-incompatible]');
      if (checkbox && checkbox.checked !== revealIncompatible) checkbox.checked = revealIncompatible;
    }

    root.querySelectorAll('[data-rt70-fitment]').forEach((card) => {
      const item = card.closest('.grid__item') || card;
      const status = api.checkFitment(card.dataset.rt70Fitment, bike);
      const badge = item.querySelector('.rt70-fitment-badge');
      item.dataset.fitmentStatus = status;
      const badgeText = status === 'compatible' ? '✓ Compatible' : 'No compatible';
      if (badge && badge.textContent !== badgeText) badge.textContent = badgeText;
      item.hidden = Boolean(bike && status === 'incompatible' && !revealIncompatible);
    });
  }

  function scheduleFitment() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyFitment();
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-rt70-reveal-incompatible]')) return;
    revealIncompatible = event.target.checked;
    applyFitment();
  });

  document.addEventListener('DOMContentLoaded', () => {
    applyFitment();
    new MutationObserver((records) => {
      const hasNewCards = records.some((record) =>
        Array.from(record.addedNodes).some((node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('[data-rt70-fitment]') || node.querySelector?.('[data-rt70-fitment]'))
        )
      );
      if (hasNewCards) scheduleFitment();
    }).observe(document.body, { childList: true, subtree: true });
  });
  document.addEventListener('rt70:ymm-change', () => applyFitment());
  document.addEventListener('rt70:ymm-ready', () => applyFitment());
  document.addEventListener('rt70:products-added', () => applyFitment());
})();
